"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _styledMediaQuery = _interopRequireDefault(require("styled-media-query"));
var _appearWrapper = require("../../animations/appearWrapper");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const Papper = _styledComponents.default.div`
  ${({
  theme
}) => (0, _styledComponents.css)`
    display: flex;
    flex-direction: column;
    align-items: center;
    animation: ${_appearWrapper.appearFromRight} 0.2s;
    background-color: ${theme.colors.white};
    justify-content: center;
    margin: 2rem auto;
    padding: ${theme.spacings.xxhuge} ${theme.spacings.large};
    width: 70%;

    ${_styledMediaQuery.default.lessThan('medium')`
      width: calc(100% - 40px);
      margin: 20px auto;
    `}

    ${_styledMediaQuery.default.lessThan('small')`
      padding: ${theme.spacings.xhuge} ${theme.spacings.medium};
      width: calc(100% - 20px);
      margin: 10px auto;
    `}
  `}
`;
var _default = Papper;
exports.default = _default;